import { FiItemsListType } from '../fi-items-list/fi-items-list-type';

export function fiItemsListTypeNameTextId(itemsListType: FiItemsListType, totalCount: number) {
    const isPlural = totalCount !== 1;
    switch (itemsListType) {
        case FiItemsListType.Documents:
            return isPlural ? 'common.documents' : 'common.document';
    }
}
